import { useEffect, useState } from "react";
import settingsService from "../services/settingsService";

export function useSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    settingsService
      .get()
      .then((res) => {
        if (mounted) setSettings(res.data);
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return { settings, loading };
}
